export const DefaultContent = '<p>&nbsp;&nbsp;&nbsp;loading app...</p>'
export const DEFAULT_ACTION_CONFIRM_PROMPT = 'Are you sure?'
